import React from 'react';
import { Switch, Router, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { MuiThemeProvider } from '@material-ui/core/styles';
import PrivateRoute from './components/PrivateRoute';
import CssBaseline from '@material-ui/core/CssBaseline';
import LuxonUtils from '@date-io/luxon';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import CompetenciesPage from './pages/CompetenciesPage';
import LoginPage from './pages/LoginPage';
import SwipesPage from './pages/SwipesPage';
import SpotCheck from './pages/SpotCheckPage';
import ProgressDialog from './components/ProgressDialog';
import { createTheme, defaultTheme } from './themes';
import isEmptyObject from './utilities/is/isEmptyObject';
import BrowserSupport from './components/BrowserSupport';
import { init } from 'workers/mediator';
// import { reactPlugin} from "appInsights";
// import { AppInsightsErrorBoundary } from "@microsoft/applicationinsights-react-js";

const fallbackTheme = defaultTheme();

class App extends React.Component {

    componentDidMount() {
        if (this.props.store) {
            init(this.props.store);
        }
    }

    render() {
        const { history, loadingConfig } = this.props;

        return (
            // <React.StrictMode>
            // <AppInsightsErrorBoundary onError={() => <h1>I believe something went wrong</h1>} appInsights={reactPlugin}>
                <BrowserSupport>
                    <MuiPickersUtilsProvider utils={LuxonUtils}>
                        <MuiThemeProvider theme={this.props.theme}>
                            <CssBaseline />
                            <ProgressDialog open={loadingConfig}>
                                Loading initial configuration, please wait..
                            </ProgressDialog>
                            <Router history={history}>
                                <Switch>
                                    <PrivateRoute exact path="/" component={SwipesPage} requirements="swipes" alt="/spotCheck" />
                                    <PrivateRoute path="/spotCheck" component={SpotCheck} requirements="spotCheck" />
                                    <PrivateRoute path="/competencies" component={CompetenciesPage} requirements="swipes" alt="/spotCheck" />
                                    <Route path="/login" component={LoginPage} />
                                    <Redirect to="/" />
                                </Switch>
                            </Router>
                        </MuiThemeProvider>
                    </MuiPickersUtilsProvider>
                </BrowserSupport>
            // </AppInsightsErrorBoundary>
            /* // </React.StrictMode> */
        );
    }
}

function mapStateToProps(state) {
    const { auth, config, theme } = state;
    return {
        auth,
        config,
        needsTheme: !theme || isEmptyObject(theme.theme),
        theme: theme.theme ? createTheme(theme.theme) : fallbackTheme,
        loadingConfig: isEmptyObject(config) || config.requesting
    };
}

const connectedApp = connect(mapStateToProps)(App);

export default connectedApp;